import styles from './overlay-styles.less';

const Overlay = ({ children, visible }) => (
    <div
        className={`${styles['rprogress-overlay'] || 'rprogress-overlay'} ${
            visible ? styles['rprogress-overlay_active'] || 'rprogress-overlay_active' : ''
        }`}
    >
        {children}
    </div>
);

export default Overlay;
